var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavigateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "navigate-icon_svg__icon",
    d: "M23.56 10.937L13.063.44A1.499 1.499 0 0012 0c-.385 0-.77.147-1.063.44L.44 10.937a1.504 1.504 0 000 2.126L10.937 23.56c.293.293.678.44 1.063.44.385 0 .77-.147 1.063-.44L23.56 13.063a1.504 1.504 0 000-2.126zM11.998 22.499L1.5 11.998 11.998 1.5h.004L22.5 12.003 11.998 22.5zM15.51 10.5H9.75a2.25 2.25 0 00-2.25 2.25v1.875c0 .207.168.375.375.375h.75A.375.375 0 009 14.625V12.75a.75.75 0 01.75-.75h5.76l-2.56 2.364a.374.374 0 00-.021.53l.508.55c.14.152.378.162.53.021l3.674-3.392a1.126 1.126 0 00-.003-1.65l-3.672-3.39a.375.375 0 00-.53.022l-.507.55c-.141.152-.131.39.02.53l2.562 2.365z",
    fill: "#C4C4C4"
  })));
}

export default __webpack_public_path__ + "./fonts/navigate-icon.bb6c469d459360e1f220a30e64ccc020.svg";
export { SvgNavigateIcon as ReactComponent };